
import { Menu } from './Menu';
import { About } from './about';
import { Footer } from './footer';

function App() {
  return (
    <div className="App">
      <Menu />
      <About /> 
      <Footer />
      
    </div>
  );
}

export { App };

